import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { ExternalPatientRoleGuard } from "../../shared/authguards/external-patient-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const QUESTION_ROUTES: Routes = [
  {
    path: "question",
    loadComponent: () => import("./question.component").then(m => m.QuestionComponent),
    canActivate: [AuthGuard, epakRoleGuard, ExternalPatientRoleGuard],
    data: { title: "pageTitles.question" },
    children: [
      {
        path: "",
        loadComponent: () => import("./question-info/question-info.component").then(m => m.QuestionInfoComponent),
        data: { title: "pageTitles.question" },
      },
      {
        path: "review",
        loadComponent: () => import("./question-review/question-review.component").then(m => m.QuestionReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.questionReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.questionMessages" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
